import React from 'react';

import { PeoWallet } from 'src/components/peo';

export const WalletAccountPagePeoAdmin: React.FC = () => {
  return <PeoWallet />;
};
